import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { useParams, useNavigate } from 'react-router-dom';
import useApiCallHooks from '../../../../hooks/useApiCallHooks';
import AdminAppBody from '../../../../components/admin/AdminAppBody';
import { uiRoutes } from "../../../../routes/ui/uiRoutes";

const RoboticsImageEdit = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [response, loading, error, callAPI, statusCode] = useApiCallHooks();

  const [form, setForm] = useState({
    kit_id: '',
    type: '',
    file: null,
  });

  const [kits, setKits] = useState([]);
  const [isFetching, setIsFetching] = useState(true);

  // Fetch kit list and media data
  useEffect(() => {
    callAPI('get', 'admin/robotic-kits');
    callAPI('get', `admin/robotic-media/${id}`);
  }, [id]);

  // Handle API responses
  useEffect(() => {
    if (statusCode === 200 && response?.data) {
      if (Array.isArray(response.data)) {
        const kitOptions = response.data.map((kit) => ({
          label: kit.name,
          value: kit.id,
        }));
        setKits(kitOptions);
      } else if (response.data.kit_id || response.data.type) {
        // Media data response
        setForm((prev) => ({
          ...prev,
          kit_id: response.data.kit_id,
          type: response.data.type,
        }));
        setIsFetching(false);
      } else if (response?.message) {
        toast.success(response.message);
        navigate('/admin/robotics-media-list');
      }
    } else if (statusCode >= 400 && response?.message) {
      toast.error(response.message);
    }
  }, [response, statusCode]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    setForm((prev) => ({ ...prev, file: e.target.files[0] }));
  };

  const handleSelectChange = (selected) => {
    setForm((prev) => ({ ...prev, kit_id: selected?.value }));
  };

  const handleSubmit = () => {
    const formData = new FormData();
    formData.append('kit_id', form.kit_id);
    formData.append('type', form.type);
    if (form.file) {
      formData.append('file', form.file);
    }
    formData.append('_method', 'PUT'); // Laravel compatibility

    callAPI('post', `admin/robotic-media/${id}`, formData, true);

    // Handle successful update


  };
  useEffect(() => {
  if (statusCode === 202) {
    toast.success("Robotics Image updated successfully!");
    setTimeout(() => navigate(uiRoutes.admin.roboticsimage.list), 1000);
  }
}, [response, statusCode, navigate]);

  return (
    <AdminAppBody
    loading={loading}
      content={
        <div className="container mt-4">
          <h4>Edit Kit Media</h4>

        
            <>
              <div className="mb-3">
                <label className="form-label">Select Kit</label>
                <Select
                  options={kits}
                  value={kits.find((k) => k.value === form.kit_id)}
                  onChange={handleSelectChange}
                  placeholder="Select Kit"
                  required
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Type</label>
                <select
                  name="type"
                  value={form.type}
                  onChange={handleChange}
                  className="form-control"
                  required
                >
                  <option value="">Select Type</option>
                  <option value="image">Image</option>
                  <option value="video">Video</option>
                </select>
              </div>

              <div className="mb-3">
                <label className="form-label">File (optional)</label>
                <input
                  type="file"
                  name="file"
                  className="form-control"
                  onChange={handleFileChange}
                  accept={form.type === 'image' ? 'image/*' : 'video/*'}
                />
              </div>

              <button className="btn btn-primary" onClick={handleSubmit}>
                Update
              </button>
            </>
         
        </div>
      }
    />
  );
};

export default RoboticsImageEdit;
